module.exports = __webpack_public_path__ + "static/img/cdr.cb189246.png";